import { _ } from "../../../core/polyglot/polyglot.js";
import { makeMonitorRepository } from "../../../core/repositories/repositoryBuilders.js";
import AgencyUser from "../../../models/AgencyUser.js";
import CompanyUser from "../../../models/CompanyUser.js";
import session from "../../../core/session.js";

/**
 * Service responsible for all data exchange required for the period
 * report notification.
 *
 * @param {string} companyId - The id of the company the period report
 *   belongs to
 */
export default class PeriodReportNotificationService {
	constructor({ companyId }) {
		const antiForgeryToken = session.getAntiForgeryToken();

		this._notificationRepository = makeMonitorRepository({
			route: "/Accounting2/Company/#companyId/PeriodReportNotification/?id",
			defaultFilters: { companyId },
			antiForgeryToken,
		});

		this._companyUsersRepository = makeMonitorRepository({
			route: "/Shared/Company/#companyId/User",
			model: CompanyUser,
			defaultFilters: { companyId },
			antiForgeryToken,
		});

		this._companyAgencyUsersRepository = makeMonitorRepository({
			route: "/Shared/Company/#companyId/AgencyUser",
			model: AgencyUser,
			defaultFilters: { companyId },
			antiForgeryToken,
		});
	}

	fetchCompanyUsers() {
		return this._companyUsersRepository.get();
	}

	fetchCompanyAgencyUsers() {
		return this._companyAgencyUsersRepository.get();
	}

	async sendNotifications({ report, emailContent }) {
		await this._notificationRepository.save({
			model: this._makeNotificationModel({ report, emailContent }),
			successMessage: _("Mail sent!"),
			errorMessage: _("Failed to send the notification!"),
		});

		emailContent.setEdited(false);
	}

	_makeNotificationModel({ report, emailContent }) {
		return {
			periodReportId: report.getId(),
			recipients: emailContent
				.getRecipients()
				.map((user) => user.getId()),
			customSubject: emailContent.getSubject(),
			customBodyText: emailContent.getBody(),
		};
	}
}
